import { useContext } from 'react'
import { PreparationContext } from '@/context/PreparationContext'

export const usePreparation = () => useContext(PreparationContext)
